
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M5.78012 2.95C7.24012 2.16 9.48012 2 12.0001 2C16.4201 2 20.0001 2.5 20.0001 6V16C20.0001 16.35 19.9201 16.67 19.8101 16.98L13.8301 11H18.0001V6H8.83012L5.78012 2.95ZM20.4901 21.9C20.1001 22.29 19.4701 22.29 19.0801 21.9L18.0701 20.89C17.8901 20.96 17.7001 21 17.5001 21C16.6701 21 16.0001 20.32 16.0001 19.5V19H8.00012V19.5C8.00012 20.33 7.33012 21 6.50012 21C5.67012 21 5.00012 20.33 5.00012 19.5V18.22C4.39012 17.67 4.00012 16.88 4.00012 16V6.83L2.10012 4.93C1.71012 4.54 1.71012 3.91 2.10012 3.52C2.49012 3.13 3.12012 3.13 3.51012 3.52L20.4801 20.49C20.8801 20.88 20.8801 21.51 20.4901 21.9ZM9.00012 15.5C9.00012 14.67 8.33012 14 7.50012 14C6.67012 14 6.00012 14.67 6.00012 15.5C6.00012 16.33 6.67012 17 7.50012 17C8.33012 17 9.00012 16.33 9.00012 15.5ZM8.17012 11L6.00012 8.83V11H8.17012Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-no-transfer`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconNoTransfer

    ```js
    <b-new-b-icon-no-transfer />
    ```
</docs>


